import { useState, useEffect, useReducer } from "react";
import { useHistory } from "react-router-dom";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { toast } from "react-toastify";

import "./addVault.css";
import SetTitle from "../../../components/setTitle/SetTitle";
import Inpt from "../../../components/crudSql/inpt/Inpt";
import AutocompleteAdd from "../../../components/crudSql/autocompleteAdd/AutocompleteAdd";
import HiddenBlock from "../../../components/crudSql/hiddenBlock/HiddenBlock";

import Button from "@mui/material/Button";
import { ArrowDropDown, ArrowDropUp, AddBox } from "@mui/icons-material";

export default function AddVault(props) {
  SetTitle("Add Vault @ DefiWatch.biz");

  // console.log("props=", props);
  const initialState = (props) => {
    return {
      //vaultId: "",
      wallet: "",
      blockchain: "",
      platform: "",
      vault: "",
      uses: "",
      name: "",
      remark: "",
    };
  };
  const [inputs, setInputs] = useState(initialState);
  const [blockchains, setBlockchains] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [name, setName] = useState("");
  const [uses, setUses] = useState([]);

  const history = useHistory();

  // const reducer = (state, action) => {
  //   if (action.type === "setBlockchain") {
  //     setBlockchains(action.payload);
  //     return { ...state, blockchain: action.payload[0].blockchain };
  //   } else if (action.type === "setPlatform") {
  //     setPlatforms(action.payload);
  //     return { ...state, platform: action.payload[0].title };
  //   }
  // };
  // const [inputs, dispatch] = useReducer(reducer, initialState);

  // Изменяем value заданного инпута при вводе внутри этого поля
  function inputChange(evt) {
    //const value = evt.target.value;

    setInputs({
      ...inputs,
      [evt.target.name]: evt.target.value,
    });
  }

  function autocompleteChange(name, val) {
    setInputs({
      ...inputs,
      [name]: val,
    });
  }

  // Действие при нажатии на кнопку
  const saveInfo = () => {
    // Если Vault.name не задан, то задаем его склейкой других полей
    // if (inputs.name === "")
    //   setInputs((prevInputs) => {
    //     return { ...prevInputs, name: name };
    //   });

    let curInputs = inputs;
    if (inputs.name === "") {
      curInputs = { ...inputs, name: name };
    }

    console.log("save: inputs =", inputs);
    console.log("posting", {
      ...curInputs,
      auth: props.userAuthWallet,
      cs: sha256(
        props.userAuthWallet + process.env.REACT_APP_SECRET
      ).toString(),
    });

    Axios.post(process.env.REACT_APP_CRUD_SRV + "/add/vault", {
      ...curInputs,
      auth: props.userAuthWallet,
      cs: sha256(
        props.userAuthWallet + process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      // console.log("saveInfo().r =", r);
      if (r.status == 200) {
        console.log("Vault has been added.");

        history.push("/vaults");
      } else {
        console.log("Error adding vault: " + r.error);
        toast.error(
          "Error adding vault. Please check the correctness of the entered data, wait a bit and try again. If this does not help, please contact support."
        );
      }
    });
  };

  const getBlockchains = () => {
    Axios.get(process.env.REACT_APP_CRUD_SRV + "/blockchains").then((res) => {
      // console.log(res.data);
      setBlockchains(res.data);
      setInputs((prevInputs) => {
        return {
          ...prevInputs,
          blockchain: res.data[0].blockchain,
        };
      });
    });
  };

  const getPlatforms = () => {
    Axios.get(
      process.env.REACT_APP_CRUD_SRV +
        "/platforms?blockchain=" +
        inputs.blockchain
    ).then((res) => {
      // console.log(res.data);
      setPlatforms(res.data.response);
      // setInputs((prevInputs) => {
      //   return {
      //     ...prevInputs,
      //     platform: res.data.response[0].title,
      //   };
      // });
    });
  };

  const getUses = () => {
    Axios.get(
      process.env.REACT_APP_CRUD_SRV +
        "/uses?blockchain=" +
        inputs.blockchain +
        "&platform=" +
        inputs.platform
    ).then((res) => {
      console.log(res.data);
      setUses(res.data.response);
    });
  };

  useEffect(() => {
    // const getBP = async () => {
    //   const blockchains = await Axios.get(
    //     process.env.REACT_APP_CRUD_SRV + "/blockchains"
    //   );
    //   console.log("blockchains =", blockchains.data);
    //   setBlockchains(blockchains.data);
    //   setInputs((prevInputs) => {
    //     return {
    //       ...prevInputs,
    //       blockchain: blockchains.data[0].blockchain,
    //     };
    //   });
    //   // dispatch({ type: "setBlockchain", payload: blockchains.data });
    //   // console.log("i1=", inputs);

    //   const platforms = await Axios.get(
    //     process.env.REACT_APP_CRUD_SRV +
    //       "/platforms?blockchain=" +
    //       inputs.blockchain
    //   );
    //   console.log("platforms =", platforms.data);
    //   setPlatforms(platforms.data.response);
    //   setInputs((prevInputs) => {
    //     return {
    //       ...prevInputs,
    //       platform: platforms.data.response[0].title,
    //     };
    //   });
    // setInputs({
    //   ...inputs,
    //   blockchain: blockchains.data[0].blockchain,
    //   platform: platforms.data.response[0].title,
    // });

    // dispatch({ type: "setPlatforms", payload: platforms.data.response });
    // console.log("i2=", inputs);
    // };
    //Runs only on the first render
    getBlockchains();
    getPlatforms();
    // getBP();

    getUses();
    // console.log(props.userWallets)
    // console.log("i3=", inputs);
  }, []);

  useEffect(() => {
    console.log("inputs =", inputs);
  }, [inputs]);

  useEffect(() => {
    console.log("props.userWallets =", props.userWallets);
    if (typeof props.userWallets[0]?.wallet !== "undefined")
      setInputs((prevInputs) => {
        return {
          ...prevInputs,
          wallet: props.userWallets[0].wallet,
        };
      });
  }, [props.userWallets]);

  useEffect(() => {
    setName(inputs.blockchain + inputs.platform + inputs.vault);
  }, [inputs.blockchain, inputs.platform, inputs.vault]);

  return (
    <div className="page addRow addVaultPage">
      {/* Datetime
Id
Wallet	Name	Blockchain	Platform	Vault	Uses	BalanceOf	PricePerFullShare	Balance	Reward	RewardToken	LpTokens	LpTokensUsd	BalanceUsd	RewardTokensUsd	RewardUsd	TotalUsd
Borrow	Claimed	TotalClaimed	TotalClaimedUsd	APR	APY	TVL	Remarks

2022-01-11 12:30:00
801
0xAfbE5E703B47Aa57F75a5Dd805651eBA13ea135F	SolanaSaberwUST-USDC	Solana	Saber	wUST-USDC		592.8448	1	592.8448	28.518	SBR		0.074683	596		2.1298	598.1298
28.518	112.365	9.5498		11.759	18803970	Claimed SBR â†’ 0.015520613 SOL
*/}

      {/* <Inpt
        label="Vault Id"
        name="vaultId"
        val={inputs.vaultId}
        type="number"
        placeholder=""
        onChg={inputChange}
      /> */}

      {/* <Inpt
        label="Wallet"
        name="wallet"
        val={inputs.wallet}
        type="text"
        placeholder="0xAfbE5E703B47Aa57F75a5Dd805651eBA13ea135F"
        onChg={inputChange}
      /> */}
      <label className="required">Wallet:</label>
      <select
        className="required"
        name="wallet"
        value={inputs.wallet}
        onChange={inputChange}
      >
        {props.userWallets.map((val, key) => {
          return (
            <option key={val.wallet} value={val.wallet}>
              {val.wallet}
            </option>
          );
        })}
      </select>

      {/* <Inpt
        label="Blockchain"
        name="blockchain"
        val={inputs.blockchain}
        type="text"
        placeholder="Solana"
        onChg={inputChange}
      /> */}
      <label className="required">Blockchain:</label>
      <select
        className="required"
        name="blockchain"
        value={inputs.blockchain}
        onChange={inputChange}
      >
        {blockchains.map((val, key) => {
          return (
            <option key={val.blockchain} value={val.blockchain}>
              {val.blockchain}
            </option>
          );
        })}
      </select>
      {/* <Inpt
        label="Platform"
        name="platform"
        val={inputs.platform}
        type="text"
        placeholder="Saber"
        onChg={inputChange}
      /> */}

      <AutocompleteAdd
        name="platform"
        value={inputs.platform}
        className="platform"
        data={platforms}
        label="Platform *, i.e. Saber"
        onChg={autocompleteChange}
        required
      />

      <Inpt
        label="Vault"
        name="vault"
        val={inputs.vault}
        type="text"
        placeholder="wUST-USDC"
        onChg={inputChange}
        required
      />

      {/* <Inpt
        label="Uses"
        name="uses"
        val={inputs.uses}
        type="text"
        placeholder="Sushi"
        onChg={inputChange}
      /> */}
      <AutocompleteAdd
        name="uses"
        value={inputs.uses}
        className="platform uses"
        data={uses}
        label="Uses *, i.e. Sushi"
        onChg={autocompleteChange}
        required
      />

      <Inpt
        label="Name"
        name="name"
        val={inputs.name}
        type="text"
        placeholder={name}
        onChg={inputChange}
        // required
      />

      <label>Remark:</label>
      <textarea name="remark" onChange={inputChange}></textarea>

      <HiddenBlock title="Technical">
        <label>PricePerFullShare:</label>
        <input
          name="pricePerFullShare"
          type="text"
          placeholder="1"
          onChange={inputChange}
        />

        <Inpt
          label="Balance LpTokens #"
          name="lpTokens"
          val={inputs.lpTokens}
          type="text"
          placeholder="0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23,0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6"
          onChg={inputChange}
        />

        <label>RewardToken:</label>
        <input
          name="rewardToken"
          type="text"
          placeholder="SBR"
          onChange={inputChange}
        />

        <Inpt
          label="Reward Tokens #"
          name="lpTokens"
          val={inputs.lpTokens}
          type="text"
          placeholder="0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE13"
          onChg={inputChange}
        />
      </HiddenBlock>

      {/* <button className="add" onClick={saveInfo}>
        Add
      </button> */}
      <Button
        variant="contained"
        className="add"
        endIcon={<AddBox />}
        onClick={saveInfo}
      >
        Add
      </Button>
    </div>
  );
}
